<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Banner acerca JIJE:
            </h3>
          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!about_jije_image"
              v-model="about_jije_image"
              :rules="rules"
              @change="onAboutJijeImageChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen Acerca JIJE"
              :messages="['Para una mejor visualización, usar un imagen PNG o JPG de 1120x160 px.']"
            ></v-file-input>

            <v-card
              v-if="about_jije_image">
              <v-img
                fixed
                :src="url_about_jije_image"
                class="grey lighten-2"
                height="160px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteAboutJijeImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Banner acerca JIJE 
              <small>(dispositivos móviles)</small>:
            </h3>
          </v-col>

          <v-col cols="12" align="center">
            <v-file-input
              outlined
              v-if="!about_jije_sm_image"
              v-model="about_jije_sm_image"
              :rules="rules"
              @change="onAboutJijeSMImageChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Imagen Acerca JIJE (SM)"
              :messages="['Para una mejor visualización, usar un imagen PNG o JPG de 600x90 px.']"
            ></v-file-input>

            <v-card
              v-if="about_jije_sm_image"
              width="600px">
              <v-img
                fixed
                :src="url_about_jije_sm_image"
                class="grey lighten-2"
                height="90px"
                width="600px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteAboutJijeSmImage()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :disabled="loading_update"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationAbout',
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      customization:[],

      about_jije_image: null,
      url_about_jije_image: null,

      about_jije_sm_image: null,
      url_about_jije_sm_image: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.customization = response.data.data.customization

          this.about_jije_image = response.data.data.customization.about_jije_image
          this.url_about_jije_image = APP_URL+ this.about_jije_image

          this.about_jije_sm_image = response.data.data.customization.about_jije_sm_image
          this.url_about_jije_sm_image = APP_URL+ this.about_jije_sm_image

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('about_jije_image', this.about_jije_image)
        formData.append('about_jije_sm_image', this.about_jije_sm_image)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-about',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
          this.loading_update=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      },

      //-------Aboout JIJE-----------
      onAboutJijeImageChange() {
        this.url_about_jije_image = URL.createObjectURL(this.about_jije_image);
      },

      deleteAboutJijeImage(){
        this.about_jije_image=null
        this.url_about_jije_image=null
      },

      onAboutJijeSMImageChange() {
        this.url_about_jije_sm_image = URL.createObjectURL(this.about_jije_sm_image);
      },

      deleteAboutJijeSmImage(){
        this.about_jije_sm_image=null
        this.url_about_jije_sm_image=null
      }

    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
